import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "lib/utils";
import { forwardRef, type TextareaHTMLAttributes } from "react";

const textareaVariants = cva("textarea textarea-bordered w-full", {
  variants: {
    size: {
      sm: "textarea-sm",
      md: "textarea-md",
      lg: "textarea-lg",
    },
    tone: {
      default: "",
      invalid: "textarea-error",
    },
  },
  defaultVariants: {
    size: "sm",
    tone: "default",
  },
});

type TextareaVariantProps = VariantProps<typeof textareaVariants>;

export type TextareaProps = {
  size?: TextareaVariantProps["size"];
  tone?: TextareaVariantProps["tone"];
} & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "className">;

/**
 * 純粋な Textarea リーフ。RHF 非依存、className は意図的に受け取らない。
 * 高さ調整は rows 属性を使う。
 * @param {TextareaProps} props Textarea の props
 * @return {JSX.Element} Textarea 要素
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size, tone, ...rest }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(textareaVariants({ size, tone }))}
        {...rest}
      />
    );
  },
);
Textarea.displayName = "Textarea";
